import React from "react";
import ReactDOM from "react-dom/client";
import "react-multi-carousel/lib/styles.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Router from "./Router";

const root = ReactDOM.createRoot(document.getElementById("root"));
let isProd = process.env.NODE_ENV === "production";

root.render(
  isProd ? (
    <React.StrictMode>
      <Router />
    </React.StrictMode>
  ) : (
    <React.Suspense>
      <Router />
    </React.Suspense>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
